import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import CurrencyDollar from '@/assets/icons/currency-dollar.svg';
import TrendingUp from '@/assets/icons/trending-up.svg';
import User from '@/assets/icons/user.svg';
import { ReachSummary } from '@/components/pages/edit-campaign/use-reach-summary';

export function useMetricContent({
  metricKey,
}: {
  metricKey: keyof ReachSummary;
}) {
  const intl = useIntl();

  return useMemo(() => {
    switch (metricKey) {
      case 'budget':
        return {
          label: intl.formatMessage({ defaultMessage: 'Total budget' }),
          icon: CurrencyDollar,
          format: (value: number) => `$${value}`,
        };
      case 'expectedCpa':
        return {
          label: intl.formatMessage({ defaultMessage: 'Target CPA' }),
          icon: CurrencyDollar,
          format: (value: number) => `$${value}`,
        };
      case 'targetApplicants':
        return {
          label: intl.formatMessage({ defaultMessage: 'Target applicants' }),
          icon: User,
          format: (value: number) => `${value}`,
        };
      case 'expectedConversion':
        return {
          label: intl.formatMessage({ defaultMessage: 'Target conversion' }),
          icon: TrendingUp,
          format: (value: number) => `${value}%`,
        };
      case 'targetHires':
        return {
          label: intl.formatMessage({ defaultMessage: 'Target hires' }),
          icon: User,
          format: (value: number) => `${value}`,
        };
      default:
        return {
          label: '',
          icon: '',
          format: (value: number) => `${value}`,
        };
    }
  }, [intl, metricKey]);
}
